import angular from 'angular';

import RateImport from './Rate';
import rateModal from './components/rateModal';
import starRating from './components/starRating';

const rateModule = angular.module('sling.rate', []);
export default rateModule.name;

rateModule.service('RateService', RateImport);
rateModule.component('rateModal', rateModal);
rateModule.component('starRating', starRating);
